import * as React from "react";
import { cn } from "@/lib/utils";

type Variant =
  | "primary"
  | "success"
  | "secondary"
  | "ghost"
  | "danger"
  | "outline"
  | "destructive";
type Size = "sm" | "md" | "lg";

interface ButtonV2Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const variantClass: Record<Variant, string> = {
  primary: "v2-action-primary",
  success: "v2-action-success",
  secondary:
    "v2-action-neutral border border-[var(--v2-border)] text-[var(--v2-text-strong)]",
  ghost: "v2-action-ghost bg-transparent text-[var(--v2-text-strong)]",
  danger: "v2-action-danger",
  outline:
    "v2-action-neutral border border-[var(--v2-border)] text-[var(--v2-text-strong)]",
  destructive: "v2-action-danger",
};
const sizeClass: Record<Size, string> = {
  sm: "min-h-8 px-3 py-1.5 text-xs",
  md: "min-h-10 px-4 py-2 text-sm",
  lg: "min-h-11 px-5 py-2.5 text-base",
};

const ButtonV2 = React.forwardRef<HTMLButtonElement, ButtonV2Props>(
  (
    {
      className,
      variant = "primary",
      size = "md",
      disabled,
      children,
      ...props
    },
    ref
  ) => {
    return React.createElement(
      "button",
      {
        ref,
        className: cn(
          "v2-focus-ring rounded-[var(--v2-radius-md)] font-semibold transition disabled:cursor-not-allowed disabled:opacity-60",
          variantClass[variant],
          sizeClass[size],
          className
        ),
        disabled,
        ...props,
      },
      children
    );
  }
);

ButtonV2.displayName = "ButtonV2";

export default ButtonV2;
